import L from 'leaflet';
import 'leaflet-canvas-markers';

export function canvasMarker(latLng: L.LatLngExpression, options: CanvasMarkerOptions): L.Path {
    // @ts-ignore
    return L.canvasMarker(latLng, options);
}

interface CanvasMarkerOptions {
    readonly img: ImageOptions;
}

// For more options see
// https://github.com/lipton-ice-tea/leaflet-canvas-markers/blob/d9f57c/README.md#options-img
interface ImageOptions {
    url: string;
    size: [number, number];
}
